// extracted by mini-css-extract-plugin
export var container = "_lg-0";
export var segment = "_lg-2";
export var segmentActive = "_lg-3";
export var track = "_lg-1";